(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fg-samples"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('fg-samples')) return;

    const PAGE = 24;
    const BELL = '<svg class="fgs-bell" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a6 6 0 0 0-6 6v3.6l-1.7 3.4a1 1 0 0 0 .9 1.5h13.6a1 1 0 0 0 .9-1.5L18 11.6V8a6 6 0 0 0-6-6Zm0 20a3 3 0 0 0 2.8-2H9.2A3 3 0 0 0 12 22Z"/></svg>';
    const NOTIFIED = 'fgsNotified';
    const norm = (s) =>
      String(s || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
    const esc = (s) =>
      String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    // Variants this visitor signed up for (restock email), so the button can say so.
    const readNotified = () => {
      try {
        return (JSON.parse(localStorage.getItem(NOTIFIED) || '[]') || []).map(String);
      } catch (e) {
        return [];
      }
    };
    const saveNotified = (id) => {
      try {
        const list = readNotified();
        if (!list.includes(String(id))) list.push(String(id));
        localStorage.setItem(NOTIFIED, JSON.stringify(list.slice(-200)));
      } catch (e) {}
    };
    class FgSamples extends HTMLElement {
      connectedCallback() {
        this.d = JSON.parse(this.querySelector('[data-fgs-data]').textContent);
        this.t = this.d.t;
        this.q = this.querySelector('[data-fgs-q]');
        this.brand = this.querySelector('[data-fgs-brand]');
        this.stock = this.querySelector('[data-fgs-stock]');
        this.chips = [...this.querySelectorAll('[data-fam]')];
        this.grid = this.querySelector('[data-fgs-grid]');
        this.empty = this.querySelector('[data-fgs-empty]');
        this.count = this.querySelector('[data-fgs-count]');
        this.clearBtn = this.querySelector('[data-fgs-clear]');
        this.more = this.querySelector('[data-fgs-more]');
        this.moreBtn = this.querySelector('[data-fgs-more-btn]');
        this.msg = this.querySelector('[data-fgs-msg]');
        this.mode = 'server';
        this.matches = [];
        this.shown = 0;
        this.seq = 0;
        this.products = {};
        this.divDone = !!this.grid.querySelector('[data-fgs-divider]');

        let timer;
        this.querySelector('[data-fgs-filterform]').addEventListener('submit', (e) => {
          e.preventDefault();
          this.apply();
        });
        this.q.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.apply(), 200);
        });
        this.brand.addEventListener('change', () => this.apply());
        this.stock.addEventListener('change', () => this.apply());
        this.chips.forEach((chip) =>
          chip.addEventListener('click', () => {
            chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
            this.apply();
          })
        );
        this.clearBtn.addEventListener('click', () => {
          this.q.value = '';
          this.brand.value = '';
          this.stock.checked = false;
          this.chips.forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
          this.apply();
        });
        this.addEventListener('submit', (e) => {
          const form = e.target.closest('[data-fgs-add]');
          if (!form) return;
          e.preventDefault();
          this.add(form);
        });
        // Warm up the product data as soon as a restock button is pointed at or focused.
        const warm = (e) => {
          const link = e.target.closest && e.target.closest('[data-fgs-notify]');
          if (link) this.product(link.getAttribute('href').split('?')[0]).catch(() => {});
        };
        this.addEventListener('pointerover', warm);
        this.addEventListener('focusin', warm);
        this.addEventListener('click', (e) => {
          const link = e.target.closest('[data-fgs-notify]');
          if (!link || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          this.notify(link);
        });
        window.addEventListener('stoq:restock-modal:submitted', (e) => {
          const v = e.detail && e.detail.variant;
          const id = v && typeof v === 'object' ? v.id : v;
          if (!id) return;
          saveNotified(id);
          this.markNotified();
        });
        this.moreBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.loadMore();
        });

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
          }, { rootMargin: '0px 0px 600px 0px' });
          this.io.observe(this.more);
        }

        this.markNotified();
        const url = new URL(window.location.href);
        const q0 = url.searchParams.get('q') || '';
        const fams0 = (url.searchParams.get('fam') || '').split(',').filter(Boolean);
        const stock0 = url.searchParams.get('stock') === '1';
        if (q0) this.q.value = q0;
        if (stock0) this.stock.checked = true;
        this.chips.forEach((chip) => {
          if (fams0.includes(chip.dataset.fam)) chip.setAttribute('aria-pressed', 'true');
        });
        if (q0 || fams0.length || stock0) this.apply();
      }

      index() {
        if (!this.idx) {
          this.idx = fetch(this.d.indexUrl, { credentials: 'same-origin' })
            .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const list = JSON.parse(doc.querySelector('[data-fg-samples-index]').textContent);
              list.forEach((p) => {
                p.q = norm(p.t);
              });
              return list;
            })
            .catch(() => {
              this.idx = null;
              return null;
            });
        }
        return this.idx;
      }

      selectedFams() {
        return this.chips.filter((c) => c.getAttribute('aria-pressed') === 'true').map((c) => c.dataset.fam);
      }

      syncUrl(q, brand, fams, stock) {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        q ? url.searchParams.set('q', q) : url.searchParams.delete('q');
        brand ? url.searchParams.set('filter.p.vendor', brand) : url.searchParams.delete('filter.p.vendor');
        fams.length ? url.searchParams.set('fam', fams.join(',')) : url.searchParams.delete('fam');
        stock ? url.searchParams.set('stock', '1') : url.searchParams.delete('stock');
        history.replaceState(history.state, '', url);
      }

      async apply() {
        const seq = ++this.seq;
        const rawQ = this.q.value.trim();
        const brand = this.brand.value;
        const fams = this.selectedFams();
        const stock = this.stock.checked;
        this.clearBtn.hidden = !(rawQ || brand || fams.length || stock);
        this.syncUrl(rawQ, brand, fams, stock);

        const list = await this.index();
        if (seq !== this.seq) return;
        if (!list) {
          // Index unavailable: fall back to Shopify's own brand filter.
          const url = new URL(this.d.url, window.location.origin);
          if (brand) url.searchParams.set('filter.p.vendor', brand);
          window.location.href = url.toString();
          return;
        }
        const tokens = norm(rawQ).split(/\s+/).filter(Boolean);
        this.matches = list.filter(
          (p) =>
            (!stock || p.a) &&
            (!brand || p.b === brand) &&
            (!fams.length || p.f.some((f) => fams.includes(f))) &&
            tokens.every((tk) => p.q.includes(tk))
        );
        this.mode = 'client';
        this.grid.innerHTML = '';
        this.shown = 0;
        this.divDone = false;
        this.renderNext();
        this.count.textContent = this.t.count.replace('__N__', this.matches.length);
        this.empty.hidden = this.matches.length > 0;
      }

      renderNext() {
        const next = this.matches.slice(this.shown, this.shown + PAGE);
        let html = '';
        next.forEach((p) => {
          if (!p.a && !this.divDone) {
            html += this.divider();
            this.divDone = true;
          }
          html += this.card(p);
        });
        this.grid.insertAdjacentHTML('beforeend', html);
        this.shown += next.length;
        this.setMore(this.shown < this.matches.length);
        this.markNotified();
      }

      setMore(visible) {
        this.more.hidden = !visible;
        if (this.io && visible) {
          this.io.unobserve(this.more);
          this.io.observe(this.more);
        }
      }

      async loadMore() {
        if (this.busy || this.more.hidden) return;
        if (this.mode !== 'client') {
          // First 24 came from the server; continue from the full list.
          this.busy = true;
          const list = await this.index();
          this.busy = false;
          if (!list) return;
          const brand = this.brand.value;
          const stock = this.stock.checked;
          this.matches = list.filter((p) => (!stock || p.a) && (!brand || p.b === brand));
          this.shown = this.grid.querySelectorAll('.fgs-card').length;
          this.divDone = !!this.grid.querySelector('[data-fgs-divider]');
          this.mode = 'client';
        }
        this.renderNext();
      }

      divider() {
        return (
          `<li class="fgs-divider" data-fgs-divider><span class="fgs-divider__icon" aria-hidden="true">${BELL}</span>` +
          `<div><h2 class="fgs-divider__title">${esc(this.t.divTitle)}</h2><p class="fgs-divider__text">${esc(this.t.divText)}</p></div></li>`
        );
      }

      card(p) {
        const t = this.t;
        let img = '';
        if (p.m) {
          const srcset = [180, 270, 360, 540].map((w) => esc(p.m.replace(/width=\d+/, 'width=' + w)) + ' ' + w + 'w').join(', ');
          img = `<img class="fgs-card__img" src="${esc(p.m)}" srcset="${srcset}" sizes="(max-width: 749px) 46vw, 220px" width="360" height="${p.h}" loading="lazy" alt="">`;
        }
        const size = p.s ? `<span class="fgs-card__size">${esc(p.s)}</span>` : '';
        const meta = `<p class="fgs-card__meta">${size}<span class="fgs-card__price">${esc(p.p)}</span></p>`;
        let badge = '';
        if (!p.a) badge = `<span class="fgs-card__badge fgs-card__badge--soldout">${esc(t.soldout)}</span>`;
        else if (p.r <= 12) badge = `<span class="fgs-card__badge">${esc(t.bestseller)}</span>`;
        const action = p.a
          ? `<form method="post" action="${esc(this.d.addUrl)}" class="fgs-card__form" data-fgs-add>${meta}` +
            `<input type="hidden" name="id" value="${p.i}"><input type="hidden" name="quantity" value="1">` +
            `<button type="submit" class="fgs-card__btn">${esc(t.add)}</button></form>`
          : `<div class="fgs-card__form">${meta}` +
            `<a class="fgs-card__btn fgs-card__btn--notify" href="${esc(p.u)}" data-fgs-notify data-variant="${p.i}">${BELL}<span>${esc(t.notify)}</span></a></div>`;
        return (
          `<li class="fgs-card${p.a ? '' : ' fgs-card--soldout'}" data-variant-id="${p.i}">` +
          `<a class="fgs-card__media" href="${esc(p.u)}" tabindex="-1" aria-hidden="true">${img}${badge}</a>` +
          `<div class="fgs-card__body"><p class="fgs-card__brand">${esc(p.b)}</p>` +
          `<h3 class="fgs-card__title"><a href="${esc(p.u)}">${esc(p.n)}</a></h3>${action}</div></li>`
        );
      }

      markNotified() {
        const ids = readNotified();
        if (!ids.length) return;
        this.querySelectorAll('[data-fgs-notify]:not(.is-done)').forEach((link) => {
          if (!ids.includes(link.dataset.variant)) return;
          link.classList.add('is-done');
          link.querySelector('span').textContent = this.t.onList;
        });
      }

      // STOQ (back in stock app) loads its storefront script on this page; wait briefly for it.
      stoq(ms) {
        return new Promise((resolve) => {
          const t0 = Date.now();
          const tick = () => {
            const s = window._Stoq || window._RestockRocket;
            if (s && typeof s.openModal === 'function') return resolve(s);
            if (Date.now() - t0 > ms) return resolve(null);
            setTimeout(tick, 150);
          };
          tick();
        });
      }

      product(base) {
        if (!this.products[base]) {
          this.products[base] = fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
            .catch((e) => {
              delete this.products[base];
              throw e;
            });
        }
        return this.products[base];
      }

      // Opens STOQ's own signup popup for this variant, so the signup lands in STOQ and
      // the restock email goes out automatically. Without STOQ: the product page, which
      // has the same Notify me button.
      async notify(link) {
        if (link.getAttribute('aria-busy') === 'true') return;
        const href = link.getAttribute('href');
        const base = href.split('?')[0];
        link.setAttribute('aria-busy', 'true');
        try {
          const stoq = await this.stoq(4000);
          if (!stoq) throw new Error('no stoq');
          const product = await this.product(base);
          if (!product || !product.variants) throw new Error('no product');
          // Only this variant: STOQ's own picker would also list the old 3 and 5 ml sizes.
          // Without the picker the popup shows just the product title, so the scent goes in it
          // (display only; STOQ stores the signup on the variant id).
          const id = Number(link.dataset.variant);
          const v = product.variants.find((x) => x.id === id);
          stoq.openModal(v ? Object.assign({}, product, { title: product.title + ' – ' + v.title, variants: [v] }) : product, id);
        } catch (e) {
          window.location.href = href;
        } finally {
          link.removeAttribute('aria-busy');
        }
      }

      showMsg(text, withCartLink) {
        this.msg.querySelector('[data-fgs-msg-text]').textContent = text;
        this.msg.querySelector('[data-fgs-msg-link]').hidden = !withCartLink;
        this.msg.hidden = false;
        clearTimeout(this.msgTimer);
        this.msgTimer = setTimeout(() => (this.msg.hidden = true), withCartLink ? 12000 : 6000);
      }

      async add(form) {
        const btn = form.querySelector('button[type="submit"]');
        const label = btn.textContent;
        btn.disabled = true;
        this.msg.hidden = true;
        try {
          const json = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
          const cart = await fetch(this.d.cartUrl + '.js', json).then((r) => r.json());
          const id = Number(new FormData(form).get('id'));
          const res = await fetch(this.d.addUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          });
          const body = await res.json();
          if (!res.ok) {
            this.showMsg(body.description || this.t.error, false);
            btn.disabled = false;
            return;
          }
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: null, sourceId: 'fg-samples', data: { itemCount: cart.item_count + 1, source: 'fg-samples' } },
            })
          );
          btn.textContent = this.t.added;
          setTimeout(() => {
            btn.textContent = label;
            btn.disabled = false;
          }, 2000);
        } catch (e) {
          this.showMsg(this.t.error, false);
          btn.disabled = false;
        }
      }
    }

    customElements.define('fg-samples', FgSamples);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mykonos-page"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Scroll reveal voor Mykonos hero elements
  document.addEventListener('DOMContentLoaded', () => {
    const reveals = document.querySelectorAll('.mk-reveal');
    if (!reveals.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('mk-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  });

  } catch(e) { console.error(e); }
})();
})();
